import React from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";

function CampaignTenantDetailsPage(props) {
    return <GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"Campaign Tenant Details"}
                            editHref={"/campaign-tenant/update"}
                            endpoint={"campaign-tenant/read"}
                            relations={["campaign", "tenant"]}
                        />
}

export default CampaignTenantDetailsPage;